var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFj(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#68bfe5",
    d: "M.3 0v40h53.4V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35.4 16.1v11.4c0 3.7 6.7 5.9 6.7 5.9s6.7-2.2 6.7-6V16.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d21034",
    d: "M41.2 20.1v5.1h-5.8v1.9h5.8v6l1 .3.8-.4v-6h5.8v-1.8h-5.7v-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d21034",
    d: "M35.4 16.1h13.4v4.4H35.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 3,
    strokeWidth: 0.1,
    d: "M36.5 19.4q.6 0 .7-.6t-.7-.6q-.7 0-.8.6.1.5.8.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 3,
    strokeWidth: 0.1,
    d: "M36.5 18.8q.6 0 .7-.3t-.7-.4-.7.4q0 .2.7.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 3,
    strokeWidth: 0.1,
    d: "M36.5 19.5q.6 0 .7-.4 0-.2-.7-.3t-.7.3q0 .3.7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 3,
    strokeWidth: 0.1,
    d: "M36.5 19.1q.6 0 .7-.3 0-.4-.7-.4t-.7.4.7.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd100",
    stroke: "#000",
    strokeMiterlimit: 3,
    strokeWidth: 0.1,
    d: "m48.5 19.6-.1-.3q-.2 0-.3-.3 0-.6-.5-.6h-.3l-.6.1h-.2l-.2-.2-.3-.2q.4 0 .8-.5l.5-.2q-.2.4 0 .3c.4-.2 0-.7 0-.7H47l-.1.1q-.1-.8-.3-.7v.1q-.3.5-.9.1c-.3-.1-1.3.2-1.6.3q-.5.4-1.4 0-.6-.3-.8-.1H41v-.1q-.2-.3 0-.3-.2-.1-.2.5l.1.3h.1q.1.1.2 0s0 .5.5.6v-.2l-.1-.1v-.2h.4l.4.1v-.3s.4.5.6.5l.7-.2.7-.2c.6-.1 1.5-.4 1.8-.1l.1.3s0 .4-.8.2l-.3-.1s0-.2-1.6.3h-.2l-.5.1c-.3.1-1.4.5-2.1.4h-.4.1v-.1q-.7-.3-.5-.4v.1-.4l.6-.4H40l-.1-.7-.7.4q-.2-.5-.4-.5v.6h.1l-.4.5v.2h-.7l-.8-.4q-.3 0-.3.2s-.5 0-.6.2c0 0-.4.1 0 .4v.2l.1-.2.2.3V18l.1.1h.3l.2-.3h.2l.5.3q.3.3.4.2v.3H38h.5v.2l-.2.4-.6.4h-.1l-.4-.2H37V19l-.1-.1h-.2v.1h-.2v.1h-.3v.2q-.2.2-.1.3c0 .5 1 .3 1 .3l.3.1.3.2.5-.2q.7-.3.6-.4.3 0 .3-.3v.1l-.1.3.4-.2q.3-.1.2-.2.3.7.4.6v-.3h.2l-.1-.2.2.1.2.2v-.1h.3c.4.2 1 0 1 0l.2-.1q.3-.1.2-.2.8-.1.8-.3.3-.1.2-.2l.4-.2c.5-.7 1.3-.3 1.3-.3h-.4c-1.2 0-.7.7-.7.7q.4.1.4.5c-.2.4-.7 0-.8-.2l-.3-.2s-.7.1-.4.6q0 .2.3.4t.9.2l.9-.4.4-.4q0-.3-.4-.4V19c.4.2.5-.5.5-.5l.3.5v-.6c.5.9.8.7.8.7q-.2-.2-.1-.3c.2.9 1.2 0 1.2 0v.4q.2 0 .2.2c0 .2-.5.1-.5.1s-.4 0-.4.4h.4l.1.1h.6q.3-.1.2-.2.5-.1.4-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M36.1 18h.2v-.3.3zM48 20h-.7l.2-.2-.2.3h.7m-4.9.2.1-.4q-.3.3-.1.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M42.7 19.8q0 .3.3.4-.3-.1-.3-.4l.2-.4zm4.3 0v.3zl.2-.1zM37 18v.2h-.2a.1.1 0 0 1 0-.2v-.1l-.1.1v.2h.3zq.6-.1.6-.3-.1.2-.5.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M36.4 17.9v.1l.1.1h.2-.2zl.1-.2zm-.3 1.7v-.1h.2l.1.2v.1-.3H36zm.8-.5-.2.2v.1l.1.3-.1-.3v-.1zv.2h.1zm-.4.2.1.5zh.1zm-.1 0v.2zm3.6-1.8.1.3v.2q0 .2.5.2l.1.1h.2l.7.4q0 .2-.7.2h-.1l.4.5-.6-.1.2.5-.3-.1h-.2l-.2-.2.1.2h-.1v.3q-.2 0-.5-.5l-.2.2h-.3v-.4h-.8l.2-.4v-.1H38v-.1l.1-.3-.4-.1.2-.1V18h.2v.1H38v.1l-.3.2.5.1-.1.2v.2h.4l-.2.6.8-.1v.3l-.1.2.4-.1.2-.1.4.4.1-.2h.2v-.2l.2.2h.3l-.2-.4h.6q0-.2-.3-.5.7 0 .7-.2l-.6-.3-.3-.2h-.1q-.5 0-.5-.2v-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m38.6 17.4-.2.3H38l.1.2h.3l-.2.5h.4l.1.2v.3l.4-.4.3.3.1-.3v-.2l.2.2h.3-.1v-.3l-.1-.1h.1l.2.1-.1-.2v-.5.7l-.2-.1v.3h.2q-.2.2-.2 0l-.3-.1v.4q-.4-.1-.3-.2v-.1l-.2.1-.2.3v-.2l-.2-.3h-.3l.2-.4H38v-.2h.4zl.3-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m39 16.9-.2.2q.7 0 1.2.5l.1-.2C39.8 17 39 17 39 17m0 0s.7 0 1 .5v.1q-.5-.4-1-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m38.9 17.3-.1.2-.1.3v.3q0 .4.4.3l.4-.3.2-.1.1-.1v-.1l.2-.3-.1.3-.2.2h-.2v.1l-.4.2q-.3.1-.4-.2l.1-.6zl.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M38.8 18h.2v.2h.3-.3V18zl-.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M39 17.8h-.1v.1l.1.1h.2a.2.2 0 0 0-.3-.2m0 .2h.3zm0 .2.1-.1zm-.2-.2v.2zm0 0 .1.2.1.1h.3v-.1H39q0 .2-.2 0zm.1-.5-.1.2zh.2zm.6.3.1.3zm-.5 0 .1.2zm.2-.5q.2 0 0 .3l.1-.2q0-.2-.1-.1m.8.3-.2-.1h-.2l-.2.2.2-.2h.2q0 .2.2 0m-.1.1h-.4zm-.1.1h-.2zm-.1 0-.1-.1zm-.4-.3H39m0-.1.1.3v-.3m-.1.1.1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M39 17.5h.1v-.2zm.3.1v.2zm.9.9q.5.2.6.4zm.1.5q.1.3.3.3zm-.5 0 .2.5zm-.6 0v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m36.1 18 .1.3V18m.3.1v.2h.1V18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m36.5 18.1.1.1h.1V18zm.4 0v.1h-.2V18zm-.7 1.4v-.2zm.5-.2V19h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7 18.2h-.2l.2-.2zm0 0h.2l-.2-.2zm-.5 1.3v-.2l.1.2zm.5-.2V19h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.5 19.3v-.2h.1v.2zm-.2 0v-.1h.2v.1l-.2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00a651",
    stroke: "#000",
    strokeMiterlimit: 4.8,
    strokeWidth: 0.1,
    d: "M38.8 22.5s.4.4.3.8c0 0 .3-.6 0-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#964b36",
    stroke: "#000",
    strokeMiterlimit: 4.8,
    strokeWidth: 0.1,
    d: "M38.3 23q-.2 0 0 .2-.2 0 0 .4l-.1.3v.5h.3V23q-.1-.1-.2 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00a651",
    stroke: "#000",
    strokeMiterlimit: 4.8,
    strokeWidth: 0.1,
    d: "M38.4 22.4s-.5-1-1-1q-.4-.2-.3-.4l.3.1q.6.2 1 .8zm0-.1s.2-1.2 1-1.2.5 0 .7-.1l-.9.3c-.3 0-.6.7-.6.9zm.2.5s.2-.5.5-.3c0 0-.3-.5-.7 0zm-.7-.5s.3 1.1-.1 1.5l-.2-1c-.3-.3.2-.7.3-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00a651",
    stroke: "#000",
    strokeMiterlimit: 4.8,
    strokeWidth: 0.1,
    d: "m38 22.5.5.6v-.6l-.6-.2v.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#964b36",
    stroke: "#000",
    strokeMiterlimit: 4.8,
    strokeWidth: 0.1,
    d: "m37 23.8.2.2.1.2v.2l.2.3.3-.1-.1-.3-.1-.3-.1-.2-.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00a651",
    stroke: "#000",
    strokeMiterlimit: 4.8,
    strokeWidth: 0.1,
    d: "M37.3 23.5s-.6-.2-1 .1c0 0 .6 0 .6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00a651",
    stroke: "#000",
    strokeMiterlimit: 4.8,
    strokeWidth: 0.1,
    d: "M37.1 23.9H37c0-.1-.6-.3-.7.3 0 0-.2-.6.1-.6q.4-.2.7.3Zm-.4-1 .3.4-.3-.5Zm-.2-.7s-.1-.6-.3-.4l-.2.5s-.4-.4-.1-.7q.5-.4.6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#964b36",
    stroke: "#000",
    strokeMiterlimit: 4.8,
    strokeWidth: 0.1,
    d: "M37 23.3v.1h.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00a651",
    d: "M36.9 22.7s0-.5.3-.7l-.1.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 4.8,
    strokeWidth: 0.1,
    d: "M36.9 22.7s0-.5.3-.7l-.1.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00a651",
    stroke: "#000",
    strokeMiterlimit: 4.8,
    strokeWidth: 0.1,
    d: "M37 22s.5-1 1.2-.7c0 0-.7.2-1 .7l-.3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00a651",
    d: "m36.6 22.5-.2-.9h-.5s.3-.3.7 0q.5.4.3.6v.6z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 4.8,
    strokeWidth: 0.1,
    d: "m36.6 22.5-.2-.9h-.5s.3-.3.7 0q.5.4.3.6v.6l-.3-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00a651",
    stroke: "#000",
    strokeMiterlimit: 4.8,
    strokeWidth: 0.1,
    d: "M37.2 23.4s-.7-1.3-1.1-.3v.3l-.1-.6c0-.5.8-.3 1 0q.4.6.3.7Zm2 .4s.5-1 .8-.6v.4s-.3-.3-.5 0v.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00a651",
    stroke: "#000",
    strokeMiterlimit: 4.8,
    strokeWidth: 0.1,
    d: "m40 23.6.1.4s.4-.7-.1-.7zm0-.7s.6.2.6.4q.1-.2-.2-.7s-.5.1-.4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00a651",
    d: "M40.3 22c.2-.6.6.2.6.2s.1-.6-.2-.7-.6 1.2-.6 1.2l-.4.1s0-1.1.7-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 4.8,
    strokeWidth: 0.1,
    d: "M40.3 22c.2-.6.6.2.6.2s.1-.6-.2-.7-.6 1.2-.6 1.2l-.4.1s0-1.1.7-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00a651",
    stroke: "#000",
    strokeMiterlimit: 4.8,
    strokeWidth: 0.1,
    d: "M39.8 22.3s-.4-.8-.7-.9.1-.2.3 0q.4.1.4.8zm-.5 1.1q0-.2.5-.7h.6l-.5.2-.1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#964b36",
    stroke: "#000",
    strokeMiterlimit: 4.8,
    strokeWidth: 0.1,
    d: "m39.2 23.8-.2.4v.4l.2.1.1-.5.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M38.3 23.2h.1zm0 .4h.3zm-.1.3q0 .1.4 0-.4.2-.4 0m-1 0 .3-.1zm.1.3.3-.2zm0 .2.4-.1zm1.7-.2.2.1h.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#964b36",
    d: "M46.3 24.8h-.1v-.4H46v-1.1.2-.3l-.3-.2v1.6l-.3.2v.1h.1v.1h.2l.1-.1h.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5 25h.1zv-.2l.2-.2V23l.3.2v.3-.2.9l.1.1v.4h.1v.1H46v.1h-.3l-.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#964b36",
    d: "M45.7 25h.6v-.1l-.1-.1h-.1v-.1H46l-.1.1h-.3l-.1.2zm-.2-.2h-.1v.1h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7 25h.6v-.1l-.1-.1h-.1v-.1H46l-.1.1h-.3l-.1.2zm-.2-.2h-.1v.1h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeMiterlimit: 4.8,
    strokeWidth: 0.1,
    d: "M46.2 23.2H46l.1-.2zM46 23l-.2.1V23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeMiterlimit: 4.8,
    strokeWidth: 0.1,
    d: "M46 23v.2q-.2 0-.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeMiterlimit: 4.8,
    strokeWidth: 0.1,
    d: "m45.9 23.2-.1.1-.2-.1.1-.2q.2 0 .2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeMiterlimit: 4.8,
    strokeWidth: 0.1,
    d: "M46 23.3v.1l-.2-.1.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00a651",
    stroke: "#000",
    strokeMiterlimit: 4.8,
    strokeWidth: 0.1,
    d: "M46.1 21.8s1.2-1.6 2.4 0l-.1.4v-.1h-.1V22H48v-.2.1-.1l-.2.2v-.4l-.2.3v-.2.1-.1l-.1.1-.2-.1v.2l-.2-.2v.1-.1.1h-.5v.1h-.4l.1.1s1.3-.3 1.3 1.2l-.2.1v-.1l-.2-.2v-.2l-.1-.2H47v-.2l-.1.2v-.1h-.2l-.2-.1h-.4s1.1.7.8 1.8h-.1V24l-.1.2v-.4h-.2v-.3l-.1.1-.1-.3v.1l-.1-.2v.1L46 23h-.4l-.2.3V23v.1-.1l-.2.4v-.3l-.1.3H45v.2l-.1.2v-.1h-.1v.3l-.1-.1v.2h-.1v.3s-.3-.6 0-1.2l1-.8H45l-.1.1v-.1l-.1.2v-.2l-.2.3v-.2.2-.2l-.1.3v-.3l-.1.3v-.3l-.1.3-.1-.2v.3l-.2-.3v.4-.2.3-.1.4-.1.2l-.2-.3v.3s-.1-1 .6-1.3q1.2-.1 1.3.1l-.3-.2V22H45v-.2h-.4l-.3.3v-.4.1h-.1v.1l-.1-.2v.2l-.2-.1v.1h-.4v.2h-.1l-.1.1V22l-.1.2s.6-1.7 2.3-.6l.2.3v-1.1.5l.1-.2v.2l.2-.3-.2.8s.1-.7.4-.8l-.3.5h.1v.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M46 22.5h.2zm-.1-.6v.1h.1l-.1.2.2-.3zv-.2zm-.2.1.2.4v.1-.2zh-.2m-.2.4h.2v.2-.2zm.2.5v-.2zm.3 0v-.2zm.1 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00a651",
    d: "M37.2 28.4h-.4.3zm0 0v.5l.1-.4M37 28l-.2.1v.3l.3-.3zm0 0v-.4zm-.1 0-.1-.3h-.2l.1.2zm.4.4.3.2v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 4.8,
    strokeWidth: 0.1,
    d: "M37.2 28.4h-.4.4m0 0v.5l.1-.4M37 28l-.2.1v.3l.3-.3V28m0 0v-.4.4m-.1 0-.1-.3h-.2l.1.2h.1m.4.4.3.2v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M37.3 28.4v.2zV28zm-.3 0h.3v-.1zm.3-.3-.5-.2zm-.2-.1v-.2zm.2.3.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39.6 28.4q.3-.2.2-.4l-.3.2c.2-.1.5-.7.5-.7q-.3.3-1.1.6c-.4.2-.2.8-.2.8l-.3-.7q0-.4-.5-.4l-.4.3-.4.2h.4l.3.3c0 .2-.2 1.1.2 1.6.3.3 1.3.5 1.3.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 4.8,
    strokeWidth: 0.1,
    d: "M39.6 28.4q.3-.2.2-.4l-.3.2c.2-.1.5-.7.5-.7q-.3.3-1.1.6c-.4.2-.2.8-.2.8l-.3-.7q0-.4-.5-.4l-.4.3-.4.2h.4l.3.3c0 .2-.2 1.1.2 1.6.3.3 1.3.5 1.3.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M38.8 29.1s.1-.4.4-.4l.5-.3c.1 0 1-.3 1-.7 0 0 0 .7-.8 1l.7-.3s-.3.5-1 .6c0 0 .6 0 .7-.2 0 0-.2.4-.7.4h.5q0 .2-.5.3h.1s-.2.4-.5.1h-.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 4.8,
    strokeWidth: 0.1,
    d: "M38.8 29.1s.1-.4.4-.4l.5-.3c.1 0 1-.3 1-.7 0 0 0 .7-.8 1l.7-.3s-.3.5-1 .6c0 0 .6 0 .7-.2 0 0-.2.4-.7.4h.5q0 .2-.5.3h.1s-.2.4-.5.1h-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39.4 29.7s.4.6.4.9c0 0 .6.7.9.7l-.4-.1.3.2h-.2.1-.3l-.1.1h-.2l-.2.2-.4-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 4.8,
    strokeWidth: 0.1,
    d: "M39.4 29.7s.4.6.4.9c0 0 .6.7.9.7l-.4-.1.3.2h-.2.1-.3l-.1.1h-.2l-.2.2-.4-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m39.8 31.6-.5-1zm.5-.1-1-1h.1zm.2 0-1-1v-.1l1 1m-2.6-3.3h-.2zm-.4 0v.2zm.4 0h-.2zm0 0h-.2zm-.1 0h-.1zm0 1.9.2.2h.1l-.2-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#964b36",
    d: "M46.1 27.9s.5-.6.9-.5l.7.3-.2.4c-.2 0-.5-.4-.7-.3l-.3.4s-.6 0-.4-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#964b36",
    stroke: "#000",
    strokeMiterlimit: 4.8,
    strokeWidth: 0.1,
    d: "m44.4 30.9-.1.1h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#964b36",
    stroke: "#000",
    strokeMiterlimit: 4.8,
    strokeWidth: 0.1,
    d: "M44.3 31q-.1-.1-.5.2l-.4.9c-.1 0 1-.5 1-.8V31h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#964b36",
    d: "M44.3 31q-.1-.1-.3.4t-.4.6m4-4.3q-.2 0-.2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3 31q-.1-.1-.3.4t-.4.6m4-4.3q-.2 0-.2.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff200",
    d: "M44.8 28.4s0-.8.8-.8v.2h.3l.2.2.2.1.2.1.1.2q.2-.1.2 0l.3.2q0 .5-.5 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8 28.4s0-.8.8-.8v.2h.3l.2.2.2.1.2.1.1.2q.2-.1.2 0l.3.2q0 .5-.5 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M46.8 28.5s.1.7-.3 1c.5-.3.4-1 .4-1m-.4.8c.2-.3.3-1 .3-1s-.1.7-.4 1M46 29l.4-.9zm0 0 .4-.9zm-.2-.2q.2-.8.4-.8-.2 0-.4.8m-.2-.1q.2-.8.4-.9c.2-.1-.5.3-.4.9m-.5-.2a1 1 0 0 1 .6-.7 1 1 0 0 0-.6.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00a651",
    d: "M44.4 29.5s-.1-.8.4-1l.4.1h.1q.2 0 .3.2l.2.2h.2l.1.2s.4 0 .3.2h.1q.2 0 .2.3l-.8.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4 29.5s-.1-.8.4-1l.4.1h.1q.2 0 .3.2l.2.2h.2l.1.2s.4 0 .3.2h.1q.2 0 .2.3l-.8.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00a651",
    d: "M44.1 30.3s-.2-.6.2-.8h.5l.2.1v.1h.3v.2l.3.2.1.1.1.1q.1 0 0 .2l-.6.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1 30.3s-.2-.6.2-.8h.5l.2.1v.1h.3v.2l.3.2.1.1.1.1q.1 0 0 .2l-.6.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00a651",
    d: "M44.4 30.9s-.5-.4-.3-.5h.3l.2.1v.1h.2l.2.1v.2l.2.1h-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m45.8 30.2.7-.7s-.4.6-.7.7m-.1-.1.7-.7zm-.2 0 .6-.9s-.3.7-.6.8m0-.2c0-.3.5-.8.5-.8s-.5.5-.6.8m-1-.4q.2-.9.4-1-.2.1-.4 1m.3 0 .4-.9c.2-.3-.5.6-.4 1m.3.2q.2-.7.5-.9s-.5.4-.5.9m-.8.7q-.2-.7.1-.9-.2.1-.1 1m.1 0 .1-.9q-.2.2 0 1m.7.5.7-.6zm0-.1.6-.6-.7.6m-.1 0 .6-.7zm-.5-.3.3-1q-.2.2-.2 1m.2.1c.3-.2.4-.9.4-.9s-.1.7-.4.9m.2 0q.4-.2.5-.7 0 .2-.5.8m0-1-.2 1zq.1-.8.3-1-.2.1-.3 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M45.3 29.8s-.1.6-.5.8c.4-.2.5-.8.5-.8l.5-.8zm-1 .7v.4zm.1 0v.4zm0 .5.2-.5zm0 0q.3-.1.3-.4zm0 0 .4-.3-.3.2m0 .2.5-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m44.5 31 .6-.1q-.4.2-.6 0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 4.8,
    strokeWidth: 0.3,
    d: "M35.4 16.1v11.4c0 3.7 6.7 5.9 6.7 5.9s6.7-2.2 6.7-6V16.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M.3 0H27v20H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m3.5 0 10.1 7.5L23.8 0H27v2.6L17 10l10 7.5V20h-3.3l-10-7.5-10 7.5H.3v-2.5l10-7.4-10-7.4V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "m18 11.7 9 6.6V20l-11.3-8.3zm-7.7.8.3 1.5-8 6H.3zM27 0v.1L16.6 8l.1-1.9L25 0zM.3 0l10 7.3H7.8L.3 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.4 0v20H17V0zM.4 6.7v6.6H27V6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "M.3 8v4H27V8zm11.4-8v20h4V0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFj);
export default __webpack_public_path__ + "static/media/fj.67ca569432ef44e3986294d48ebff88c.svg";
export { ForwardRef as ReactComponent };